<template>
    <div>
        <v-card>
            <v-card-title>
                <v-col cols="9">
                    <v-card-text>
                        <v-card-title class="titulopagina">DETALLE DE MOVIMIENTO N° {{movimiento?movimiento.id:''}}</v-card-title>
                    </v-card-text>
                </v-col>
                <v-col cols="2" class="text-center" v-if="(user && (user.id==1))">
                    <v-btn color="red darken-4" dark icon @click="eliminar_movimiento(movimiento.id)">
                        Eliminar <v-icon>delete</v-icon> Movim
                    </v-btn>
                </v-col>
                <v-col cols="1">
                    <v-btn color="green darken-1" class="float-right" small dark @click="download" v-bind:disabled="!can_download">Excel</v-btn>
                </v-col>
            </v-card-title>
            <v-card-text>
                <table style="width:100%;">
                <thead>
                    <tr>
                        <th class="text-center cabecera">
                            Fecha
                        </th>
                        <th class="text-center cabecera">
                            Tipo Movimiento
                        </th>
                        <th class="text-center cabecera">
                            Motivo Movimiento
                        </th>
                        <th class="text-center cabecera">
                            Bodega Origen
                        </th>
                        <th class="text-center cabecera">
                            Bodega Destino
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-center">
                            {{ movimiento?movimiento.fecha:'' |formatearFecha }}
                        </td>
                        <td class="text-center">
                            {{movimiento? movimiento.tipo_movimiento_texto:''}}
                        </td>
                        <td class="text-center">
                            {{movimiento? movimiento.motivo_movimiento_texto:''}}
                        </td>
                        <td class="text-center">
                            {{movimiento? movimiento.bodega_origen_texto:''}}
                        </td>
                        <td class="text-center">
                            {{movimiento? movimiento.bodega_destino_texto:''}}
                        </td>
                    </tr>
                </tbody>
            </table>
            </v-card-text>
        </v-card>

        <v-card class="mt-2">
          <v-card-text>
            <v-row>
              <v-col v-for="d in datos" :key="d.id">
                <div class="dato">
                    <span class="dato-nombre">{{ d.nombre_dato }}:</span>

                    <template v-if="d.tipo_dato === 'Archivo'">
                        <span class="dato-valor">
                            <v-btn
                                v-if="d.valor_dato"
                                    icon
                                    color="red darken-1"
                                    @click="abrirArchivo(d.url)"
                                >
                                <v-icon>description</v-icon>
                            </v-btn>
                            <p v-else>-</p>
                        </span>
                    </template>

                    <template v-if="d.tipo_dato === 'Fecha'">
                        <span class="dato-valor texto">{{ d.valor_fecha | fechaCompleta }}</span>
                    </template>

                    <template v-if="d.tipo_dato === 'Texto' || d.tipo_dato === 'Numero'">
                        <span class="dato-valor texto">{{ d.valor_dato }}</span>
                    </template>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="mt-2">
            <v-card-text>
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th class="text-center cabecera" colspan="6"> {{ movimiento ? movimiento.tipo_movimiento_texto : '' }} Maxisacos</th>
                            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                        </tr>
                        <tr>
                            <th class="text-center cabecera">
                                Fecha Elaboración
                            </th>
                            <th class="text-center cabecera">
                                Lote
                            </th>
                            <th class="text-center cabecera">
                                N°
                            </th>
                            <th class="text-center cabecera">
                                Formato
                            </th>
                            <th class="text-center cabecera">
                                Peso
                            </th>
                            <th class="text-center cabecera">
                                Eliminar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="m in maxisacos" :key="m.id">
                            <td class="text-center">
                                {{m.jumbos.fecha_resultado_analisis |fechaCompleta}}
                            </td>
                            <td class="text-center">
                                {{m.jumbos.lote.nombre_lote}}
                            </td>
                            <td class="text-center">
                                {{m.jumbos.nro_jumbo}}
                            </td>
                            <td class="text-center">
                                {{ formatos.filter( f => f.id == m.jumbos.formato_maxisacos_id) ? 
                                    formatos.filter( f => f.id == m.jumbos.formato_maxisacos_id)[0].formato : null }}
                            </td>
                            <td class="text-center">
                                {{m.jumbos.peso}}
                            </td>
                            <td class="text-center">
                                <v-btn color="red darken-4" dark small icon @click="eliminar_maxis(m.movimientos_id, m.jumbos.id, m.jumbos.nro_jumbo)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </v-card-text>
        </v-card>
        <v-card class="mt-2">
            <v-card-text v-if="(movimiento != null) && (movimiento.tipo_movimiento == 'S') && ((movimiento.motivo_movimiento >= 2) && (movimiento.motivo_movimiento <= 4))">
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th class="text-center cabecera" colspan="6">Maxisacos Obtenidos</th>
                        </tr>
                        <tr>
                            <th class="text-center cabecera">
                                Fecha Elaboración
                            </th>
                            <th class="text-center cabecera">
                                Lote
                            </th>
                            <th class="text-center cabecera">
                                N°
                            </th>
                            <th class="text-center cabecera">
                                Formato
                            </th>
                            <th class="text-center cabecera">
                                Peso
                            </th>
                            <th class="text-center cabecera">
                                Eliminar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="j in jumbos.detalles" :key="j.id">
                            <td class="text-center">
                                {{j.jumbos.fecha_resultado_analisis |fechaCompleta}}
                            </td>
                            <td class="text-center">
                                {{j.jumbos.lote.nombre_lote}}
                            </td>
                            <td class="text-center">
                                {{j.jumbos.nro_jumbo}}
                            </td>
                            <td class="text-center">
                                {{ formatos.filter( f => f.id == j.jumbos.formato_maxisacos_id)[0].formato || null }}
                            </td>
                            <td class="text-center">
                                {{j.jumbos.peso}}
                            </td>
                            <td class="text-center">
                                <v-btn color="red darken-4" dark small icon @click="eliminar_jumbos(j.movimientos_id, j.jumbos.id, j.jumbos.nro_jumbo)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import ConfirmDialogue from '@/components/ConfirmDialogue.vue';
export default {
    data:()=>({
        id:null,
        movimiento:null,
        datos:[],
        maxisacos:[],
        formatos:[],
        bodegas:[],
        alert:false,
        jumbos: [],
        can_download: true,
    }),
    mounted(){
        console.log(`id: ${this.$route.params.id}`);
        this.id = this.$route.params.id;
        this.cargar_movimiento();
        this.cargar_bodegas();
        this.cargar_formatos();
    },
    methods:{
        async cargar_movimiento(){
            this.mostrarLoading({titulo:'Cargando movimiento...',color:'green'})
            await this.axios.get(`${this.base_url}movements/${this.id}`,this.headers).then((res)=>{
                let data = res.data.data
                this.movimiento = data.movimiento;
                this.maxisacos = data.movimiento.detalles;
                this.datos = data.datos;
                this.jumbos = data.jumbos ? data.jumbos : [];
                this.ocultarLoading();
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar movimiento ");
            });
        },

        async cargar_bodegas(){
            this.mostrarLoading({titulo:'Cargando bodegas...',color:'green'})
            await this.axios.get(`${this.base_url}bodegas`,this.headers).then((res)=>{
                this.bodegas = res.data.data;
                this.ocultarLoading();
            }).catch(e=>{
                this.errorMessage(e, "Error al cargar bodegas ");
            });
        },

        async cargar_formatos(){
            await this.axios.get(`${this.base_url}jumbo/formato_maxisacos`,this.headers).then((res)=>{
                this.formatos = res.data.data;
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar formatos de maxisacos ");
            });
        },

        async eliminar_maxis(movimiento,id,nro){
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: `Desea eliminar maxisaco nro ${nro} del listado ?`,
                okButton: 'Eliminar !!',
            })
            if(okei) {
                await this.axios.get(`${this.base_url}movements/${movimiento}/${id}/eliminar`,this.headers).then((res)=>{
                    let idx = this.maxisacos.findIndex(m => m.jumbos.id == id);
                    this.maxisacos.splice(idx,1);
                }).catch((e)=>{
                    this.errorMessage(e, "Error al eliminar maxisaco.");
                })
            }
        },

        async eliminar_jumbos(movimiento, id,nro){
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: `Desea eliminar maxisaco nro ${nro} de los maxisacos obtenidos ?`,
                okButton: 'Eliminar !!',
            })
            if(okei) {
                await this.axios.get(`${this.base_url}movements/jumbo/${movimiento}/${id}`,this.headers).then((res)=>{
                    let idx = this.jumbos.findIndex(m => m.jumbos.id == id);
                    this.jumbos.splice(idx,1);
                }).catch((e)=>{
                    this.errorMessage(e, "Error al eliminar maxisaco..");
                })
            }
        },

        async eliminar_movimiento(movimiento){
            let url = `${this.base_url}movements/${movimiento}`;
            let item = {_method:"DELETE", id: movimiento}
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: `Desea eliminar este movimiento ?? este paso no se puede deshacer !!!`,
                okButton: 'Eliminar !!',
            })
            if(okei) {
                await this.axios.post(url, item, this.headers).then((response)=>{
                    this.$router.push({name:'movimientos'});
                }).catch((error)=>{
                    this.errorMessage(error, "Error al eliminar maxisaco..");
                });
            }
        },

        abrirArchivo(url){
            window.open(url, '_blank');
        },

        async download(){
            await this.axios.get(`${this.base_url}movimientos_a_excel/${this.id}`, this.headers).then((res)=>{
                window.location.href = this.download_url.replace('bitacoras', 'movimientos') + res.data;
            }).catch((e)=>{
                this.errorMessage(e, "Error al descargar excel..");
            })
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed:{
        ...mapState(['user','base_url', 'headers', 'download_url']),
    },
    components:{
        ConfirmDialogue
    }
}
</script>
<style scoped>
    .dato {display: flex; align-items: center; margin-bottom: 10px;}
    .dato-nombre { margin-right: 10px; font-weight: bold;}
    .dato-valor { text-align: center;}
    .texto{ padding-top: 10px;}
    .dato-nombre{padding-top: 10px;}
</style>